<template>
  <YesNoRadio
    v-model="visited"
    :label="$tt(`ever_visited_${country!}`)"
  />
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';

const country = inject(countryKeyInjectionKey);
const visited = defineModel<boolean>({ required: true });
</script>